import { OrderConversionListFormValues } from 'pages/Monitoring/OrderConversion/OrderConversionList/hooks/useOrderConversionFilter';
import { OrderConversionListFilterChips } from 'pages/Monitoring/OrderConversion/OrderConversionList/OrderConversionListFilter/OrderConversionListFilterChips';
import { OrderConversionListFilterForm } from 'pages/Monitoring/OrderConversion/OrderConversionList/OrderConversionListFilter/OrderConversionListFilterForm';
import {
  ConversionPeriod,
  OrderConversionListPeriodToggle,
} from 'pages/Monitoring/OrderConversion/OrderConversionList/OrderConversionListPeriodToggle/OrderConversionListPeriodToggle';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { FilterContextProvider } from 'shared/mui/Filter/context/filterContext';
import {
  FilterApplyButton,
  FilterButton,
  FilterClearButton,
  FilterResetButton,
} from 'shared/mui/Filter/FilterButtons';
import { FilterChipsToolbar } from 'shared/mui/Filter/FilterChipsToolbar/FilterChipsToolbar';
import {
  FilterDrawer,
  FilterDrawerActionsButtons,
  FilterDrawerContent,
} from 'shared/mui/Filter/FilterDrawer';
import { FilterToolbar } from 'shared/mui/Filter/FilterToolbar/FilterToolbar';

type Props = {
  onReset: VoidFunction;
  setPeriod: (value: ConversionPeriod) => void;
  form: UseFormReturn<OrderConversionListFormValues, any, any>;
  onSubmit: (values: OrderConversionListFormValues) => void;
  toggleDrawer: (value: boolean) => VoidFunction;
  isListFilterExist: boolean;
  period: ConversionPeriod;
  openDrawer: boolean;
  appliedFilters: Record<string, any>;
  setAppliedFilter: (name: string, value: any) => void;
};

export const OrderConversionListFilter: React.FC<Props> = ({
  onReset,
  setPeriod,
  form,
  toggleDrawer,
  isListFilterExist,
  period,
  openDrawer,
  appliedFilters,
  setAppliedFilter,
  onSubmit,
}) => {
  const translate = useTypedTranslate();
  return (
    <>
      <FilterToolbar
        leftActionsSlot={[<FilterButton key="filter" onClick={toggleDrawer(true)} />]}
        rightActionsSlot={[
          <OrderConversionListPeriodToggle
            key="period-toggle"
            onChange={(_, newValue) => {
              if (newValue !== null) {
                setPeriod(newValue);
              }
            }}
            value={period}
          />,
        ]}
        sx={{ padding: '10px 0' }}
      />
      <FilterDrawer onClose={toggleDrawer(false)} open={openDrawer}>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FilterDrawerContent sx={{ gap: '0' }}>
              <OrderConversionListFilterForm />
            </FilterDrawerContent>
            <FilterDrawerActionsButtons>
              <FilterResetButton label={translate('app.buttons.reset')} onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterDrawerActionsButtons>
          </form>
        </FormProvider>
      </FilterDrawer>
      <FilterChipsToolbar appliedFilters={appliedFilters}>
        <FilterContextProvider appliedFilters={appliedFilters} setAppliedFilter={setAppliedFilter}>
          <FormProvider {...form}>
            <OrderConversionListFilterChips />
            <FilterClearButton key="clear" onClick={onReset} visible={isListFilterExist} />
          </FormProvider>
        </FilterContextProvider>
      </FilterChipsToolbar>
    </>
  );
};
